import NotFound from '@/pages/404.vue'
import Index from '@/pages/index.vue'
import LastPublications from '@/pages/last-publications.vue'
import MissingPublications from '@/pages/missing/index.vue'
import Search from '@/pages/search.vue'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import AUTH from './auth'
import RECORDINGS from './recordings'
import SPIDERS from './spiders'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Index',
    component: Index,
  },
  {
    path: '/last',
    name: 'LastPublications',
    component: LastPublications,
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
  },
  {
    path: '/missing',
    name: 'MissingPublications',
    component: MissingPublications,
  },
  AUTH,
  SPIDERS,
  RECORDINGS,
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '*',
    name: 'NotFoundCatchAll',
    component: NotFound,
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
})

export default router
